module.exports = __webpack_public_path__ + "img/telegram-mini.00061ba0.svg";